<template>
  <div id="app">
    <nav-bar/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line import/no-unresolved
import NavBar from '@/components/NavBar.vue';
// eslint-disable-next-line import/no-unresolved
import Footer from '@/components/Footer.vue';

export default {
    name: 'App',
    components: {
        NavBar,
        Footer,
    },
};
</script>

<style>
@font-face {
  font-family: "AstroSpace";
  src: local("AstroSpace"),
    url(./assets/fonts/AstroSpace-eZ2Bg.ttf) format("truetype");
}

html {
  position: relative;
  min-height: 100%;
}

body {
    margin: 0 0 250px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #285149;
  background-color: #ffffff;
  min-height: 100vh;
  overflow: auto;
}

h1 {
  font-size: 2.55em;
  color: #dc6b31;
  font-weight: bold;
  padding: 15px 0px;
}

h2 {
  font-size: 1.8em;
  color: #e79a72;
}

h3 {
  font-size: 1.5em;
  color: #e79a72;
}

#home {
  margin-top: 0;
}

#home_text {
  max-width: 75%;
}

.pagetext {
  padding: .3vw;
  align-content: center;
}

#partnercontainer {
  padding: 3vw;
}

.partnerbuttons .btn {
  padding: 10px;
  margin: 12px;
}

.team .card-body {
  color: #0e4761;
}

@media only screen and (max-width: 800px) {

    h1 {
      font-size: 7vw;
    }

    h2 {
      font-size: 4.3vw;
    }

    #home {
      padding: 2.7vw;
    }

    #partners {
      font-size: 2vw;
      padding: 6vw 3vw 3vw 3vw;

    }
    #partnercontainer {
      padding: 10vw;
    }
}

@media only screen and (max-width: 450px) {
    h1 {
      font-size: 8.4vw;
    }

    h2 {
      font-size:6.1vw;
    }

}

/*#nav a.router-link-exact-active {
  color: #42b983;
}*/
</style>
